/* eslint-disable import/prefer-default-export */
import { createContext } from 'react';

const SheetDedicatedCustomerContext = createContext({});
export default SheetDedicatedCustomerContext;
